// Real-show player + neighbor physics: position and color are both updated
// per-frame on the CPU; this shader draws each drone as a glowing LED. The
// cymatics standing wave rides on top (uCymAmp 0 = off — ShowPlayer never
// sets the uCym* uniforms, so shows are untouched).
attribute vec3 aColor;
attribute float aSeed;

uniform float uTime;
uniform float uSize;
uniform float uBrightness;
uniform float uAudioLevel; // 0..1 overall audio energy (0 when not reacting)
uniform float uAudioBeat;  // 0..1 kick spike (0 when not reacting)
uniform float uShimmer;    // treble sparkle amount (0 = calm twinkle)
uniform float uHueShift;   // accumulated hue-drift angle (radians, 0 = off)
uniform float uCymAmp;   // cymatics standing-wave amplitude (0 = off)
uniform float uCymM;     // plate mode numbers + combination sign
uniform float uCymN;
uniform float uCymMix;
uniform float uCymL;     // plate side length (scene units)
uniform float uCymSpeed; // oscillation rate (rad/s)

varying vec3 vColor;
varying float vTwinkle;

const float PI = 3.14159265;

// rotate a colour about the grey axis (Rodrigues) — cheap hue drift
vec3 hueRotate(vec3 c, float a) {
  const vec3 k = vec3(0.57735026919);
  float ca = cos(a);
  return c * ca + cross(k, c) * sin(a) + k * dot(k, c) * (1.0 - ca);
}

void main() {
  vec3 pos = position;

  // cymatics: antinodes pump, nodal lines hold still — visual-only offset,
  // the CPU sim never sees it (mirrors drone.vert.glsl)
  if (uCymAmp > 0.0) {
    vec2 uv = pos.xz / uCymL;
    float plate = cos(uCymM * PI * uv.x) * cos(uCymN * PI * uv.y)
                + uCymMix * cos(uCymN * PI * uv.x) * cos(uCymM * PI * uv.y);
    pos.y += uCymAmp * 0.5 * plate * sin(uTime * uCymSpeed);
  }

  vec4 mv = modelViewMatrix * vec4(pos, 1.0);
  gl_Position = projectionMatrix * mv;
  // each point swells on the beat and with overall energy (Pulse effect)
  float audioSize = 1.0 + uAudioBeat * 0.55 + uAudioLevel * 0.22;
  gl_PointSize = clamp(uSize * audioSize * (8.0 / max(-mv.z, 0.001)), 1.0, 46.0);

  // treble deepens + speeds the twinkle (Shimmer effect)
  vTwinkle = 0.9 + (0.1 + 0.55 * uShimmer) * sin(uTime * (2.5 + uShimmer * 10.0) + aSeed * 120.0);
  vec3 col = aColor * uBrightness * (1.0 + uAudioLevel * 0.6 + uAudioBeat * 0.5);
  if (uHueShift != 0.0) col = hueRotate(col, uHueShift);
  vColor = col;
}
